import { Session } from '@ais-ui/auth';

export type GotoEventResponse = {
  lat: number;
  lon: number;
  zoomLevel: number;
};

export const gotoEvent = async (
  session: Session,
  eventId: string,
): Promise<GotoEventResponse> => {
  const response = await session.request('gotoEvent', {
    serverUid: 'd4bd4710-1765-4476-8969-09ab9d0b676f',
    eventId: eventId,
    useCurrentPosition: false,
  });

  return response;
};
